const S = Symbol("SVG_LOAD"), E = Symbol("UI_COMPONENT_EXISTS"), O = Symbol("LANGUAGE"), T = Symbol("BACKEND"), o = Symbol("FRONTEND"), s = Symbol("PERSONS_STORE"), N = Symbol("PAGES_STORE"), R = Symbol("COMPONENTS_STORE"), _ = Symbol("PRODUCTS_STORE"), A = Symbol("DATA_STORE");
export {
  T as B,
  R as C,
  A as D,
  o as F,
  O as L,
  N as P,
  S,
  E as U,
  s as a,
  _ as b
};
//# sourceMappingURL=symbols-CVSaLsTy.js.map
